class CatalogSearchForm {
    constructor($el) {
        this.$el = $el;
        this.$searchForm = this.$el.find('.catalog-search-form');
        this.$searchField = this.$el.find('.catalog-search-form__field');
        this.$expandFormButton = this.$el.find('.catalog-search__expand-search-form-button');

        if(this.$searchForm.length && this.$searchField.length && this.$expandFormButton.length) {
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onSubmitFn = this._onSubmit.bind(this);
        this.onExpandFn = this._onExpand.bind(this);

        this.$searchForm.on('submit', this.onSubmitFn);
        this.$expandFormButton.on('click', this.onExpandFn);
    }

    _onSubmit(e) {
        e.preventDefault();

        const fieldValue = this.$searchField.val();
        
        if(fieldValue) {
            // window.location = `/catalogue/recherche/${encodeURIComponent(fieldValue)}`;
            window.location = `${this.$searchForm.attr('action')}${encodeURIComponent(fieldValue)}`;
        }
    }
    
    _onExpand(e) {
        e.preventDefault();

        this.$el.removeClass('catalog-search--collapsed');
    }
}

export default CatalogSearchForm;
